import { Skeleton } from "antd";
import { useFetchLocalStorage } from "../../lib/useFetchLocalStorage";
import useUser from "../../lib/useUser";
import AllClients from "components/clients/AllClients";
import SectionTitle from "../../components/shared/SectionTitle";
import * as ROUTES from "../../constants/routes";

function Client() {
  useFetchLocalStorage();
  const { status, user } = useUser({ redirectTo: "/login" });

  if (status === "loading" || !user) return <Skeleton active />;

  return (
    <>
      <SectionTitle
        title="All Clients"
        buttonTo={ROUTES.CLIENTS_ADD}
        buttonTitle="Add client"
      />
      <AllClients />
    </>
  );
}

export default Client;
